<script setup lang="ts">
import { TabsContent, useForwardPropsEmits } from 'radix-vue'
import type { TabsContentProps } from 'radix-vue'

const props = defineProps<TabsContentProps>()

const forwarded = useForwardPropsEmits(props)
</script>

<template>
  <TabsContent v-bind="forwarded">
    <slot />
  </TabsContent>
</template>
